// extracted by mini-css-extract-plugin
export default {"container":"PaymentRequestActions-module__container--TvYop"};